import { AwsUi } from '../../../core/runtime/src';
import { render, callbacks } from './common';
export var Checkbox = AwsUi.__addComponent('awsui-checkbox', {
    releaseStatus: 'stable',
    callbacks: callbacks,
    properties: {
        // Specifies whether the component is checked.
        checked: {
            type: 'boolean'
        },
        // Specifies that the component is in an indeterminate state. The checkbox
        // will display indeterminate state only if checked is false. Once an
        // indeterminate checkbox is clicked, it will become checked.
        indeterminate: {
            type: 'boolean'
        },
        // The name of the control used in HTML forms.
        name: {
            type: 'string'
        },
        // Specifies that the input should be disabled, preventing the user from
        // modifying the value and excluding the value from being included with a
        // form submit. In AngularJS use `data-disabled` instead.
        disabled: {
            type: 'boolean'
        },
        // The id of the internal input. Useful for relating a label element's
        // "for" attribute to this control.
        controlId: {
            type: 'string'
        },
        // Adds aria-labelledby on the native input. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define a custom id inside the label
        // 2. Refer to that label from every single control under that label using this property
        ariaLabelledby: {
            type: 'string'
        },
        // Adds aria-describedby on the native input. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define custom ids inside the description, hint and error text
        // 2. Refer to these from every single control under that label using this property
        // 3. Refer to any other hint/description text that you provide
        ariaDescribedby: {
            type: 'string'
        },
        // Adds an `aria-label` to the native input. Only use this when you do not have a
        // visible label for this control.
        ariaLabel: {
            type: 'string'
        }
    },
    events: {
        // Fired when input focus is set onto the UI control.
        focus: {
            bubbles: true,
            cancelable: false
        },
        // Fired when input focus is removed from the UI control.
        blur: {
            bubbles: true,
            cancelable: false
        },
        // Fired when the user changes the component state.
        // The event `detail` contains the current value for the `checked` property.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'Checkbox.ChangeDetail'
        }
    },
    render: function (m, h) {
        var icon = null;
        if (this.checked) {
            icon = AwsUi.__createElement("polyline", { points: "2.5,7 6,10 11,3" });
        }
        else if (this.indeterminate) {
            icon = AwsUi.__createElement("polyline", { points: "2.5,7 11.5,7" });
        }
        var svg = (AwsUi.__createElement("svg", { viewBox: "0 0 14 14", "aria-hidden": "true", focusable: "false" },
            AwsUi.__createElement("rect", { x: "0.5", y: "0.5", rx: "1.5", ry: "1.5", width: "13", height: "13" }),
            icon));
        return render(this, h, svg);
    },
    functions: {
        // Sets input focus onto the UI control.
        focus: function () {
            this.node.querySelector('input').focus();
        }
    },
    regions: {
        // Label for the input.
        label: {
            isDefault: true
        },
        // Extra description shown below the label.
        description: {}
    },
    wrapperSupport: {
        ngModel: {
            value: 'checked',
            event: 'change'
        }
    }
});
//# sourceMappingURL=checkbox.js.map